module.exports = __webpack_public_path__ + "img/group_bg@2x.2d30fec9.png";